import type { ReactElement } from "react";
import { useParams } from "react-router-dom";
import NotFound from "../../../NotFound/NotFound";
import { ResourceArticleMetaContext } from "./ResourceArticleMetaContext";
import { findResourceArticle } from "./data/resourceArticles";
import { ResourceArticleSeo } from "./ResourceSeo";

export const ResourceArticlePage = (): ReactElement => {
  const { category, slug } = useParams<{ category: string; slug: string }>();
  const article = findResourceArticle(category, slug);

  if (!article) {
    return <NotFound />;
  }

  const ArticleComponent = article.component;

  return (
    <ResourceArticleMetaContext.Provider value={article}>
      <ResourceArticleSeo article={article} />
      <ArticleComponent />
    </ResourceArticleMetaContext.Provider>
  );
};
